import React from 'react'

const Paycodes = () => {
    return (
        <>
            Paycodes mobile
        </>
    )
}

export { Paycodes }